import React, { useEffect, useRef, useState } from "react";

// Renders a still image, or — when src points at an .mp4/.webm served from
// public/videos/ — a silent autoplaying loop. Videos only mount once scrolled
// near the viewport (poster shows until then), so below-the-fold clips cost
// nothing on initial load.
export default function SectionMedia({ src, alt, poster, className = "" }) {
  const isVideo = /\.(mp4|webm)$/i.test(src);
  const ref = useRef(null);
  const [inView, setInView] = useState(false);

  useEffect(() => {
    if (!isVideo) return;
    const el = ref.current;
    if (!el) return;
    if (!("IntersectionObserver" in window)) {
      setInView(true);
      return;
    }
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setInView(true);
          observer.disconnect();
        }
      },
      { rootMargin: "200px" }
    );
    observer.observe(el);
    return () => observer.disconnect();
  }, [isVideo]);

  if (isVideo) {
    if (!inView) {
      return poster ? (
        <img ref={ref} src={poster} alt={alt} loading="lazy" className={className} />
      ) : (
        <div ref={ref} className={className} aria-label={alt} />
      );
    }
    return (
      <video
        src={src}
        poster={poster}
        className={className}
        autoPlay
        muted
        loop
        playsInline
        preload="metadata"
        aria-label={alt}
      />
    );
  }
  return <img src={src} alt={alt} loading="lazy" className={className} />;
}
